// extracted by mini-css-extract-plugin
export default {"title":"styles_title__uzf6V","subtitle":"styles_subtitle__cMxjF","vid":"styles_vid__HZzIt","vidContainer":"styles_vidContainer__VmF1Q"};